"use strict";

exports.__esModule = true;
exports.isPluginDisabled = void 0;
var isPluginDisabled = exports.isPluginDisabled = function isPluginDisabled(pluginOptions) {
  return !pluginOptions.enableForAllEnvironments && process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test";
};